import * as Primitives from '@radix-ui/react-checkbox'
import { CheckedState } from '@radix-ui/react-checkbox'
import * as React from 'react'

import { CheckMini } from '@/icons/check-mini'
import { MinusMini } from '@/icons/minus-mini'
import { clx } from '@/utils/clx'

export type CheckboxCheckedState = CheckedState

/**
 * This component is based on the [Radix UI Checkbox](https://www.radix-ui.com/primitives/docs/components/checkbox) primitive.
 */
const Checkbox = React.forwardRef<
	React.ElementRef<typeof Primitives.Root>,
	React.ComponentPropsWithoutRef<typeof Primitives.Root> & {
		checked?: CheckboxCheckedState | undefined
	}
>(({ className, checked, ...props }, ref) => {
	return (
		<Primitives.Root
			{...props}
			ref={ref}
			checked={checked}
			className={clx('group inline-flex h-5 w-5 items-center justify-center outline-none', className)}
		>
			<div
				className={clx(
					'h-[15px] w-[15px] rounded-[3px] bg-ui-bg-base text-ui-fg-on-inverted shadow-borders-base transition-fg [&_path]:shadow-details-contrast-on-bg-interactive',
					'group-disabled:cursor-not-allowed group-disabled:opacity-50',
					'group-focus-visible:!shadow-borders-interactive-with-focus',
					'group-hover:group-enabled:group-data-[state=unchecked]:bg-ui-bg-base-hover',
					'group-data-[state=checked]:bg-ui-bg-interactive group-data-[state=checked]:shadow-borders-interactive-with-shadow',
					'group-data-[state=indeterminate]:bg-ui-bg-interactive group-data-[state=indeterminate]:shadow-borders-interactive-with-shadow'
				)}
			>
				<Primitives.Indicator>
					{checked === 'indeterminate' ? <MinusMini /> : <CheckMini />}
				</Primitives.Indicator>
			</div>
		</Primitives.Root>
	)
})
Checkbox.displayName = 'Checkbox'

export { Checkbox }
